import { string, object } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import getRoleKeys from '../../Shared/jsonSchemaUtilities/getRoleKeys';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  const roleKeys = getRoleKeys(properties);

  // eslint-disable-next-line
  const roleSchema: { [key: string]: any } = {};

  for (const roleKey of roleKeys) {
    roleSchema[`${formatName(properties[roleKey]?.$id as string)}`] =
      string().required('This field is required');
  }

  return object({
    [`${formatName(properties['label']?.$id as string)}`]: string().required(
      'This field is required'
    ),
    [`${formatName(properties['id']?.$id as string)}`]: string()
      .required('This field is required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    ...roleSchema
  });
};
